<template>
    <div class="load-mask-parent product-info-component">
        <div :class="loadMask"></div>
        <component-title
            :config="configTitle">
        </component-title>
        <div class="text-center">
            <span v-if="shop_code"><b>{{ t('Index') }}</b>: {{ shop_code }}</span><span>&nbsp;&nbsp;&nbsp;</span>
            <span v-if="ean"><b>{{ t('Ean') }}</b>: {{ ean }}</span><span>&nbsp;&nbsp;&nbsp;</span>
            <span v-if="price"><b>{{ t('Current price') }}</b>: {{ price }}</span>
        </div>
        <div class="product-info-component-components">
            <template v-for="(component) in getComponents">
                <component
                    :is="loadComponent(component.type)"
                    :config="component.config"
                    :eventBus="$root"
                    :routeParams="routeParams"
                ></component>
            </template>
        </div>
    </div>
</template>
<script>

import ComponentTitle from "@/components/ComponentTitle.vue";
import State from "@/Models/State.ts";

export default {
    components: {ComponentTitle},
    props: {
        config: {
            Type: Object,
            default: function () {
                return {
                    index: null,
                    loadUrl: null,
                    emitEvents: {},
                    components: [],
                    description: [],
                }
            }
        },
        eventBus: {
            Type: Object,
        },
        routeParams: {
            Type: Object
        },
        queryParams: {
            Type: Object
        },
    },
    data() {
        return {
            configTitle: {},
            name: null,
            ean: null,
            price: null,
            shop_code: null,
            componentIndex: null,
            loadMask: '',
            components: [],
            state: new State(),
        };
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    inject: ['eventManager'],
    mounted() {
        this.init();
        this.setState(this.routeParams)
            .setState(this.queryParams);
        this.mountEvents();
        this.eventManager.emitEvents(this.config.emitEvents['mounted'] || [], []);
    },
    methods: {
        init() {
            this.configTitle = {
                title: this.name,
                description: this.config.description,
            };
            this.componentIndex = this.config.index;
            this.components = this.config.components;
        },
        mountEvents() {
            this.eventManager.bindEvents(this.defaultBindEvents(), this);
        },
        unmountEvents() {
            this.eventManager.unbindEvents(this.defaultBindEvents());
        },
        setState(data) {
            this.state.value = data;

            return this;
        },
        async load() {
            this.addLoadMask();
            let response = await this.fetchData(this.state.value);
            this.ean = response.data.ean;
            this.price = response.data.price;
            this.shop_code = response.data.shop_code;
            this.name = response.data.name;
            this.configTitle['title'] = this.name;
            this.removeLoadMask();
        },
        async fetchData(params) {
            const url = this.config['loadUrl'];

            return await this.$http['get'](url, {params: params});
        },
        addLoadMask() {
            this.loadMask = 'lmask';
        },
        removeLoadMask() {
            this.loadMask = '';
        },
        defaultBindEvents() {
            return [{
                name: 'load',
                componentIndex: this.componentIndex,
            }];
        },
        loadComponent(type) {
            return require(`./${type}.vue`);
        },
    },
    computed: {
        getComponents() {
            return this.components.filter(c => c.config.display).sort((a, b) => a.config.position - b.config.position);
        },
    },
}

</script>

<style lang="sass" scoped>
    .load-mask-parent {
        min-height: auto;
    }
    .product-info-component {
        position: relative;
    }
    .product-info-component-components {
        position: absolute;
        top: 15px;
        right: 15px;
    }
    .product-info-component-components > div {
        float: right;
        margin-left: 3px;
    }
</style>



// WEBPACK FOOTER //
// ProductInfoComponent.vue?e665ec68